module.exports = __webpack_public_path__ + "img/jewelryEncycZs.5834047e.png";